
export const CLUSTER_CONFIG = {
    THRESHOLDS: {
        SMALL: 50,
        MEDIUM: 200,
        LARGE: 500
    },
    ICON_SIZES: {
        SMALL: 60,
        MEDIUM: 70,
        LARGE: 100,
        XLARGE: 150
    },
    FONT_SIZES: {
        SMALL: 8,
        MEDIUM: 10,
        LARGE: 11,
        XLARGE: 12
    }
};